module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step06_e27500adb179407f06ccb5cb3a527fa9.png";